export default {
  MAX_ATTACHMENT_SIZE: 5000000,
  AUTH_DIAG_ENVIRONMENT: "CHINA_EU_STAGE",
  apiGateway: {
    REGION: "eu-west-1",
    URL: "https://c0bo5t9wh8.execute-api.eu-west-1.amazonaws.com/dev",
  },
  cognito: {
    REGION: "eu-west-1",
    USER_POOL_ID: "eu-west-1_GGLcVBIAf",
    APP_CLIENT_ID: "24bo811r115hjh0n87mskujoh9",
    APP_CLIENT_SECRET: "1oda03r5uehdvbig7akgrc6fs7mkv8cidsovqg2i2gd5o228mvlu",
    DOMAIN: "https://eu-west-1gglcvbiaf.auth.eu-west-1.amazoncognito.com",
    IDENTITY_POOL_ID: "eu-west-1:0e652c79-5f49-4b1a-b398-b53bb6404439"
  }
};
